require('./pagelist.scss');
require('../../basic.css');//var newsListtop = require('./newsListtop.ejs');
var newsItem = require('./newsItem.ejs');
var topItem = require('./topItem.ejs');
var Skeleton = require('./skeleton.ejs');

var util = require('../util');

var DataCenter = require('f.component.datacenter.pc');
var Audio = require('f.component.audio.pc');
var Pic = require('f.component.pic.pc');
var Video = require('f.component.videolist.pc');


//时间分割线
var lastItemDate = null; //最后一个比对的时间

var sortType = 'desc';

var LivePage = function (options) {
    // console.log(options);
    this.init(options);

};

LivePage.prototype.init = function (options) {
    this.options = options;

    this.dataCenter = new DataCenter(options);

    console.log('dataCenter', this.dataCenter);

    this.resolveTemplate();
    this.bindDomEvent();
    this.bindDataEvent();

};


LivePage.prototype.bindDataEvent = function () {

    //初始化渲染
    var _self = this;
    //获取页数
    this.dataCenter.on('sendPageNum', function (num) {
        if(num>1) $('.mod-showMoreBtn').show();
    });

    //置顶消息，推送消息
    this.dataCenter.on('top', function (item) {
        _self.renderTop($(_self.container.find('.js_timelineTop')[0]), item);
    });

    //当数据的发生变化时监控，items push的数据，绘制数据
    this.dataCenter.on('tail', function (items) {
        //console.log(items);
        _self.renderItems($(_self.container.find('.js_timelineContainer')[0]), items, false);

    });

    //当数据的发生变化时监控，items push的数据，绘制数据
    this.dataCenter.on('head', function (items) {
        _self.renderItems($(_self.container.find('.js_timelineContainer')[0]), items, true);
    });

    //清空数据
    this.dataCenter.on('clear', function () {
        _self.clearItem($(_self.container.find('.js_timelineContainer')[0]));
    });

};
////绑定元素中的代理事件
LivePage.prototype.bindDomEvent = function () {

    var _self = this;
    //刷新
    $('#js_refresh').bind("click", function () {

        _self.dataCenter.restart(sortType);
        return false;
    });
    //排序
    $('#js_sort').bind("click", function () {
        sortType = (sortType == "desc" ? "asc" : "desc");
        $(this).find("span").text((sortType == "desc" ? "正序" : "倒序"));
        if(sortType == "asc"){
            $(this).addClass('sortDesc');
        }else{
            $(this).removeClass('sortDesc');
        }

        _self.dataCenter.restart(sortType);
        return false;
    });

    $(this.container).find('.mod-loading').hide();


    //显示更多
    $(this.container).on('click', '.box_more', function () {
        var more = $(this);
        //more.addClass("shrinkW");
        more.hide();
        $(_self.container).find('.mod-loading').show().find("span").addClass("loading-rotate");


        _self.dataCenter.requestMore(function () {
            $(_self.container).find('.mod-loading').hide().find("span").removeClass("loading-rotate");
            more.show();
            //more.addClass("now");
            //more.removeClass("shrinkW");
        });
        return false;
    });
};



LivePage.prototype.resolveTemplate = function () {

    this.container = $(Skeleton());
    this.ownerNode = this.container;

};




//============================ 页面渲染方法
/**
 * 重画置顶
 * @param itemData 置顶数据
 */
LivePage.prototype.renderTop = function (container,itemData) {
   // itemData.isAd = true;

    var curDate = new Date();
    var year = curDate.getFullYear();
    var month = curDate.getMonth() + 1;
    var date = curDate.getDate();
    var curDateStr = year + '-' + ((month + '').length == 1 ? '0' + month : month) + '-' + ((date + '').length == 1 ? '0' + date : date);
    var dateStr = util.getDate(itemData.ctime);

    //itemData.isTop = 'true';
    itemData.abstract1 = itemData.abstract;
    if(itemData.meaning){
        itemData.covertime = itemData.meaning;
    }else{
        itemData.covertime = util.timeHandle(itemData.ctime);
    }

    itemData.daytime = util.timeHandleDay(itemData.ctime);
    itemData.hasRelyContent = itemData.quote_message.length > 0;
    itemData.hasContent = typeof itemData.abstract != 'undefined' && itemData.abstract != '';
    itemData.uid = itemData.ugcuid;
    itemData.converVedioImage = this.replaceImgServer(itemData.video_image);
    //console.log("111",itemData);

    var html = topItem({'items': [itemData]});
    container.empty();
    container.append(html);
    var contentNode = container.find('.news-con')[0];
    this.renderComponents(contentNode,itemData);
};

/**
 * 清空列表
 */
LivePage.prototype.clearItem = function (container) {
    container.empty();
    // $('.mod-showMoreBtn').show();
};

/**
 * 绘制更新的内容
 * @param {Object}container 需要绘制的容器
 * @param {Array}items 需要绘制的数据
 * @param {boolean}ishead  是否是头部添加
 * @param {boolean}isTop  是否头条
 */
LivePage.prototype.renderItems = function (container,  items, ishead,topT) {
    var _this = this;
    var contentNode,firstDate;

    var curlength = container.find('.news-con').length;
    var curDate = new Date();
    var year = curDate.getFullYear();
    var month = curDate.getMonth() + 1;
    var date = curDate.getDate();
    var curDateStr = year + '-' + ((month + '').length == 1 ? '0' + month : month) + '-' + ((date + '').length == 1 ? '0' + date : date);
    var temp = [];
    //console.log("len===",items.length);
    for (var i = 0; i < items.length; i++) {
        //console.log(items[i]);
        //console.log(!items[i].abstract,!items[i].title,!items[i].pictures.length,!items[i].video_id,!items[i].audio_url);
        if(!items[i].abstract && !items[i].title && !items[i].pictures.length && !items[i].video_id && !items[i].audio_url){
            continue;
        }
        if((items[i].audio_url && parseInt(items[i].audio_duration)) || !items[i].audio_url){//有视频，无时长不插入
            var dateStr = util.getDate(items[i].ctime)
            firstDate = (i == 0) ? dateStr : 0;

            items[i].isTop = 'false';
            items[i].abstract1 = items[i].abstract;
            items[i].covertime = util.timeHandle(items[i].ctime);
            items[i].daytime = util.timeHandleDay(items[i].ctime);
            items[i].hasRelyContent = items[i].quote_message.length > 0;
            items[i].hasContent = typeof items[i].abstract != 'undefined' && items[i].abstract != '';
            items[i].uid = items[i].ugcuid;
            items[i].user = (!this.options.isPolitics) ?  '主持人 '+items[i].user : items[i].user;

            if (items[i].hasRelyContent) {
                items[i].quote_message[0].converImage = this.replaceImgServer(items[i].quote_message[0].image);
                items[i].quote_message[0].coverCtime = util.timeHandleNosecond(items[i].quote_message[0].ctime);
            }
            items[i].converVedioImage = this.replaceImgServer(items[i].video_image);
            if (ishead) {
                items[i].isTop = false;
                items[i].ishead = true;
            }

            var contLen = $('.js_timelineContainer').children().length;//已加载的内容个数
            //contLen == 0代表初始加载，解决倒叙刷新问题
            if ((typeof lastItemDate == 'undefined' || dateStr != lastItemDate || contLen == 0) && dateStr != curDateStr) {
                items[i].dateStr = dateStr;
                lastItemDate = dateStr;
            }
           // console.log("item===",items[i]);
            var ItemDom = $(newsItem({'items': [items[i]]}));
            contentNode = ItemDom.find('.news-con')[0];


            this.renderComponents(contentNode,items[i]);

            if (ishead) {
                container.children().first().before(ItemDom);
            } else {
                container.append(ItemDom);
            }
            //最新一条新闻的时间移到推广上方，如为当天时间，则不显示
            var firstNewHasT = _this.container.find('.js_timelineContainer').find('.mod-box').eq(0).find('.mod-lineTitle');
            var topTime = _this.container.find('#js_top_time');
            if(firstNewHasT.length){
                firstNewHasT.hide();
                topTime.find('.title').html(items[0].dateStr);
                topTime.show();
            }else{
                topTime.hide();
            }
        }


    }
};


LivePage.prototype.renderComponents = function (contentNode,item) {
    var picHtml,picData,audioData,audioHtml,videoData,videoHtml;
    if (item.pictures && item.pictures.length > 0) {
        picData = {
            pictures : item.pictures,
            mid : item.mid
        };
        picHtml = new Pic(picData);
        picHtml.renderTo(contentNode);
    }
    if (item.audio_url){
        //if(parseInt(item.audio_duration)){
            audioData = {
                audio_url : item.audio_url,
                audio_id : item.audio_id,
                audio_duration : item.audio_duration
            };
            audioHtml = new Audio(audioData);
            audioHtml.renderTo(contentNode);
        //}

    }

    if (item.video_id){
        videoData =  {
            "from": "pomp",
            "uid": item.uid,
            "mid" : item.mid,
            "video_id": item.video_id,
            "video_image": item.video_image,
            "isTop" : item.isTop,
            width : 540,
            height : 360,
            videoRatio : 0.75,
            swfUrl : '//p0.ifengimg.com/a/2018/0810/2/vZHPlayer_v7.0.4.swf', // '//vxml.ifengimg.com/swf/vZHPlayer_v7.0.3.swf',
            AutoPlay: true
        };
        videoHtml = new Video(videoData);
        videoHtml.renderTo(contentNode);
    }
};


LivePage.prototype.replaceImgServer = function (imageAddr) {
    if (imageAddr == '') return '';
    return this.options.imageServer + '/' + this.options.imageRatio + '/' + imageAddr.replace(/http[s]?:\/\//, '');
};



LivePage.prototype.renderTo = function(parentNode) {
  parentNode.append($(this.container)[0]);
};






module.exports = LivePage;





// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.pagelist.pc/app/modules/view/index.js